import { render, staticRenderFns } from "./m-article-wrapper-overlap.vue?vue&type=template&id=4c24466c&scoped=true"
import script from "./m-article-wrapper-overlap.vue?vue&type=script&lang=js"
export * from "./m-article-wrapper-overlap.vue?vue&type=script&lang=js"
import style0 from "./m-article-wrapper-overlap.vue?vue&type=style&index=0&id=4c24466c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24466c",
  null
  
)

export default component.exports